<template>
  <div class="vsm-shell" style="margin-top: 20px">

    <!-- Marketing pitch for tenants without VSM access -->
    <div v-if="!vsmAccessGranted" class="rd-upsell">
      <div class="rd-upsell-icon-wrap">
        <i class="fa fa-bus rd-upsell-icon"></i>
      </div>
      <h2 class="rd-upsell-headline">Unlock Vehicle Status Manager</h2>
      <p class="rd-upsell-sub">
        Get a real-time view of every vehicle in your fleet and its readiness for dispatch.
      </p>
      <ul class="rd-upsell-list">
        <li>
          <i class="fa fa-check-circle"></i>
          <span><strong>Live Fleet Readiness</strong> — track OUT, READY, CLEAN, DIRTY, OOS, and PM statuses at a glance</span>
        </li>
        <li>
          <i class="fa fa-check-circle"></i>
          <span><strong>SMS Status Updates</strong> — wash and maintenance staff can update vehicle status by text message</span>
        </li>
        <li>
          <i class="fa fa-check-circle"></i>
          <span><strong>Departure Schedule</strong> — prioritize cleaning and identify vehicles that need swapping before upcoming bookings</span>
        </li>
        <li>
          <i class="fa fa-check-circle"></i>
          <span><strong>DVIR &amp; Maintenance</strong> — optional integration with pre-trip inspections and shop workflows</span>
        </li>
      </ul>
      <router-link
        :to="{ name: 'support_ticket_create', query: { category: 'vsm', subject: 'I\'d like to sign up for Vehicle Status Manager' } }"
        class="btn rd-upsell-cta"
      >
        <i class="fa fa-ticket"></i> Open a support ticket
      </router-link>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasVsmAccess as checkVsmAccess, vsmRouteName } from '../utils/vsm_access'

export default {
  name: 'vsm_shell',
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    features() { return this.user.features[this.user.tenant] || {} },
    tenant_type() { return this.user.types[this.user.tenant] },
    vsmAccessGranted() { return checkVsmAccess(this.features) },
  },
  mounted() {
    if (this.vsmAccessGranted && this.$route.name === 'vehstatusmgr') {
      this.$router.replace({ name: vsmRouteName(this.tenant_type, this.features) })
    }
  },
}
</script>

<style scoped>
.rd-upsell {
  max-width: 640px;
  margin: 40px auto;
  text-align: center;
  padding: 40px 32px;
  border: 2px solid #b8d0e4;
  border-radius: 10px;
  background: linear-gradient(180deg, #f0f6fc 0%, #fff 100%);
}
.rd-upsell-icon-wrap { margin-bottom: 16px; }
.rd-upsell-icon { font-size: 48px; color: var(--fi-rail-accent); }
.rd-upsell-headline { font-size: 24px; font-weight: bold; color: #1a3a5c; margin-bottom: 10px; }
.rd-upsell-sub { font-size: 15px; color: #555; margin-bottom: 24px; }
.rd-upsell-list { list-style: none; padding: 0; margin: 0 0 28px; text-align: left; display: inline-block; }
.rd-upsell-list li { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 12px; font-size: 14px; color: #333; }
.rd-upsell-list .fa-check-circle { color: var(--fi-rail-accent); font-size: 16px; margin-top: 2px; flex-shrink: 0; }
.rd-upsell-cta { background-color: var(--fi-rail-accent); color: #fff !important; font-size: 15px; font-weight: bold; padding: 10px 28px; border-radius: 6px; text-decoration: none; border: none; }
.rd-upsell-cta:hover { background-color: #2e6da4; color: #fff !important; text-decoration: none; }
.rd-upsell-cta .fa { margin-right: 6px; }
</style>
